import { Dropdown } from 'primereact/dropdown'

const normalizarBusca = texto =>
  String(texto || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

/**
 * Dropdown das ocorrências (motivos de falta/sobra) com campo de busca.
 * Recebe as mesmas props do Dropdown do primereact, com o filtro ligado por padrão.
 *
 * Ajustes sobre o filtro do primereact 3.4:
 * - a busca ignora acentos: "codigo" encontra "(CBEI) CÓDIGO BARRAS ERRADO";
 * - Enter na busca escolhe o primeiro resultado (no primereact ele só fecha a lista),
 *   a menos que a opção já escolhida, por exemplo com as setas, esteja entre os resultados;
 * - com o filtro ligado, o primereact realinha o painel a cada render, mesmo fechado,
 *   o que deixa lentas as tabelas com centenas de linhas (Resumo de Separação).
 *   Aqui o painel só é realinhado quando está aberto.
 */
export default class OcorrenciasDropdown extends Dropdown {
  static defaultProps = {
    ...Dropdown.defaultProps,
    filter: true,
    filterPlaceholder: 'Buscar...',
  }

  filter(option) {
    return normalizarBusca(this.getOptionLabel(option)).includes(
      normalizarBusca(this.state.filter.trim()),
    )
  }

  onFilterInputKeyDown(event) {
    if (event.which === 13 && this.hasFilter()) {
      const selecionada = this.findOption(this.props.value)
      if (!selecionada || !this.filter(selecionada)) {
        const primeira = this.findNextVisibleItem(-1)
        if (primeira) this.selectItem({ originalEvent: event, option: primeira })
      }
    }
    super.onFilterInputKeyDown(event)
  }

  alignPanel() {
    if (this.panel.element.offsetParent) super.alignPanel()
  }
}
